import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { fromEvent, merge, timer, Subscription } from "rxjs";
import { debounceTime, takeUntil, tap } from "rxjs/operators";
import { APPLICATIONSERVICE } from "../constants/application-service";
import { AppBaseService } from "./http.service";
import { MICROSERVICES } from "../constants/web-services";
import { AuthService } from "./auth.service";
import localForage from "localforage";
import { CookieService } from "ngx-cookie-service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ApplicationConfigService } from "./application-config.service";
import { MatDialog } from "@angular/material/dialog";
@Injectable({
  providedIn: "root",
})
export class IdleTimeoutService {
  // private timeoutInMs = 1 * 60 * 1000; // 1 minutes
  private activityEvents$: Subscription | null = null;
  private timer$: Subscription | null = null;
  userId: number;
  timeoutInMs: any;
  constructor(
    private router: Router,
    private ngZone: NgZone,
    private appBaseService: AppBaseService,
    public authService: AuthService,
    private cookieService: CookieService,
    private applicationConfigService: ApplicationConfigService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private dialog:MatDialog
  ) {}

  startWatching(): void {
    this.ngZone.runOutsideAngular(() => {
      const events = [
        fromEvent(window, "mousemove"),
        fromEvent(window, "keydown"),
        fromEvent(window, "click"),
        fromEvent(window, "scroll"),
        fromEvent(window, "touchstart"),
      ];

      this.activityEvents$ = merge(...events)
        .pipe(
          debounceTime(500),
          tap(() => this.resetTimer())
        )
        .subscribe();
    });

    this.resetTimer();
  }

  stopWatching(): void {
    this.activityEvents$?.unsubscribe();
    this.timer$?.unsubscribe();
  }

  resetTimer(): void {
    this.timer$?.unsubscribe();
    this.timeoutInMs = localStorage.getItem("sessionTimeOut");
    this.timer$ = timer(Number(this.timeoutInMs) * 60 * 1000).subscribe(() =>
      this.logout()
    );
  }

  private logout(): void {
    this.stopWatching();
    sessionStorage.removeItem("isStoreDialogOpened");
    this.signout();
    this.dialog.closeAll();
  }
  signout() {
    this.authService.getUser().then((value: any) => {
      if(value){
      this.userId = value.userId;
      let apiUrl = APPLICATIONSERVICE.UPDATE_CASH_WORKSTATION + this.userId;
      this.appBaseService.setResourceURL(MICROSERVICES.IDENTITY_SERVICE);
      this.appBaseService.putResource(apiUrl, "").subscribe(
        (res) => {},
        (error) => {
          console.log("Error", error.error.error_description);
          console.log("userId", this.userId);
        }
      );
      this.appBaseService.setResourceURL(MICROSERVICES.IDENTITY_SERVICE);
      this.appBaseService
        .postResource("user/logout", {})
        .subscribe((data) => {});
      localStorage.clear();
      localForage.clear();
      sessionStorage.clear();
      this.cookieService.deleteAll();
      this.applicationConfigService.screenConfiguration.listOfResources = [];
      this.applicationConfigService.moduleConfigurationList = [];
      this.ngxUiLoaderService.stopAll();
      this.ngZone.run(() => this.router.navigate([""]));
      }
    });
  }
}
